import { AubadeComponent } from "js/front/bootstrap/AubadeComponent";
import gsap from "gsap";

class Popin extends AubadeComponent {
    constructor(e, b) {
        super(e, b);

        window.viewport = this.viewport;

        this.value = this.element.dataset.popinInputNumberValue;
    }

    attach() {
        this.element.addEventListener("click", this.open);
    }

    detach() {
        this.element.removeEventListener("click", this.open);
    }

    attachContent() {
        this.popin.addEventListener("click", this.close);
        this.popinContent.addEventListener("click", this.stopPropagation);
        this.viewport.on("resize", this.layout);

        if (this.buttonClose)
            this.buttonClose.addEventListener("click", this.close);
        if (this.buttonLink)
            this.buttonLink.addEventListener("click", this.onButtonLinkClicked);
        if (this.buttonSubmit)
            this.buttonSubmit.addEventListener("click", this.onSubmit);
    }

    detachContent() {
        this.popin.removeEventListener("click", this.close);
        this.popinContent.removeEventListener("click", this.stopPropagation);
        this.viewport.off("resize", this.layout);

        if (this.buttonClose)
            this.buttonClose.removeEventListener("click", this.close);
        if (this.buttonLink)
            this.buttonLink.removeEventListener(
                "click",
                this.onButtonLinkClicked
            );
        if (this.buttonSubmit)
            this.buttonSubmit.removeEventListener("click", this.onSubmit);
    }

    buildPopin = () => {
        let dom = '<div class="popin">';
        dom += '<div class="content">';
        if (this.element.dataset.popinTitle)
            dom +=
                '<div class="title">' +
                this.element.dataset.popinTitle +
                "</div>";
        if (this.element.dataset.popinDescription)
            dom +=
                '<div class="description">' +
                this.element.dataset.popinDescription +
                "</div>";
        if (this.element.dataset.popinInputNumberValue)
            dom +=
                '<div class="input"> <input type="number" min="0" max="99" placeholder="' +
                this.element.dataset.popinInputNumberPlaceholder +
                '" value="' +
                this.value +
                '" /></div>';

        dom += '<div class="buttons">';
        if (this.element.dataset.popinButtonClose)
            dom +=
                '<div class="button-close">' +
                this.element.dataset.popinButtonClose +
                "</div>";
        if (this.element.dataset.popinButtonLinkText)
            dom +=
                '<div class="button-link ' +
                this.element.dataset.popinButtonLinkClass +
                '"><span>' +
                this.element.dataset.popinButtonLinkText +
                '</span><i class="icon share"></i></div>';
        if (this.element.dataset.popinButtonSubmit)
            dom +=
                '<div class="button-submit">' +
                this.element.dataset.popinButtonSubmit +
                "</div>";
        dom += "</div>";

        dom += "</div>";
        dom += "</div>";

        const div = document.createElement("div");
        div.innerHTML = dom;

        this.popin = div.firstChild;

        document.body.appendChild(this.popin);

        this.popinContent = this.popin.querySelector(".content");
        this.buttonClose = this.popin.querySelector(".button-close");
        this.buttonLink = this.popin.querySelector(".button-link");
        this.buttonSubmit = this.popin.querySelector(".button-submit");
        this.input = this.popin.querySelector(".input input");

        this.attachContent();
        this.layout();
    };

    destroyPopin() {
        document.body.removeChild(this.popin);

        this.detachContent();

        this.popin = null;
        this.popinContent = null;
        this.buttonClose = null;
        this.buttonLink = null;
        this.buttonSubmit = null;
        this.input = null;
    }

    layout = () => {
        if (this.viewport.medias.mobile) {
            this.popinContent.style.removeProperty("left");
            this.popinContent.style.removeProperty("top");
        } else {
            const bounds = this.element.getBoundingClientRect();
            const x = Math.ceil(bounds.left + bounds.width / 2);
            const y = Math.ceil(bounds.top + bounds.height + 20);

            this.popinContent.style.left = x + "px";
            this.popinContent.style.top = y + "px";
        }
    };

    get value() {
        return this._value;
    }
    set value(value) {
        if (value != this._value) {
            this._value = value;
            if (this.input) {
                this.input.value = value;
            }
        }
    }

    stopPropagation = e => {
        e.stopPropagation();
    };

    open = () => {
        const tl = gsap.timeline();

        this.buildPopin();
        tl.fromTo(this.popin, { alpha: 0 }, { alpha: 1 }, 0);

        return tl;
    };

    close = e => {
        e.stopPropagation();

        const tl = gsap.timeline();

        tl.to(this.popin, { alpha: 0 }, 0);
        tl.add(() => {
            this.destroyPopin();
        });

        return tl;
    };

    onButtonLinkClicked = e => {
        this.emit("link");

        this.close(e);
    };

    onSubmit = e => {
        if (this.input) {
            this.emit("input", this.element, this.input.value);
        }

        this.close(e);
    };
}

export { Popin };
